// schema/domain.ts
export const FRUITS = ['apple', 'orange', 'pear', 'peach', 'cherry'] as const;
export type FruitType = (typeof FRUITS)[number];
export const HEMISPHERES = ['north', 'south'] as const;
export type Hemisphere = (typeof HEMISPHERES)[number];
export const SPECIES = ['person', 'cat', 'dog', 'rabbit', 'bear', 'duck', 'frog', 'sheep', 'squirrel'] as const;
export type Species = (typeof SPECIES)[number];
export type VillagerSpecies = Exclude<Species, 'person'>;
export const PERSONALITIES = ['easygoing', 'sporty', 'grumpy', 'fancy', 'bubbly', 'sweet'] as const;
export type Personality = (typeof PERSONALITIES)[number];
export const EMOTES = ['wave', 'laugh', 'clap', 'dance', 'sit', 'surprised', 'heart', 'sleepy'] as const;
export type EmoteId = (typeof EMOTES)[number];
export const FRIEND_COLORS = ['coral', 'sky', 'lilac', 'marigold', 'teal', 'rose', 'leaf', 'clay', 'moss', 'plum'] as const;  // 10 = max humans (D-43)
export type FriendColor = (typeof FRIEND_COLORS)[number];
export const WATER_KINDS = ['river', 'pond', 'sea'] as const;
export type WaterKind = (typeof WATER_KINDS)[number];
export const ITEM_KINDS = ['furniture', 'fish', 'fossil', 'fruit', 'shell', 'tool', 'wallpaper', 'floor', 'stationery', 'wrapping', 'misc'] as const;
export type ItemKind = (typeof ITEM_KINDS)[number];
export const OBJECT_KINDS = ['tree', 'rock', 'house', 'building', 'bridge', 'decor', 'mailbox', 'board', 'dropbox', 'stump'] as const;
export type ObjectKind = (typeof OBJECT_KINDS)[number];
export const FURNITURE_CATEGORIES = ['seating', 'table', 'bed', 'storage', 'lighting', 'decor', 'rug', 'plant'] as const;
export type FurnitureCategory = (typeof FURNITURE_CATEGORIES)[number];
export const COLOR_TAGS = ['red', 'orange', 'yellow', 'green', 'blue', 'purple', 'pink', 'brown', 'white', 'black', 'beige'] as const;
export type ColorTag = (typeof COLOR_TAGS)[number];
export const SEASONS = ['spring', 'summer', 'autumn', 'winter'] as const;
export type Season = (typeof SEASONS)[number];
export const KITS = ['medieval', 'furniturebits', 'nature', 'mini'] as const;
export type KitId = (typeof KITS)[number];
export type Rot = 0 | 1 | 2 | 3;               // quarter turns clockwise seen from above; 0 faces +y (south, toward camera)
export type ShadowSize = 1 | 2 | 3 | 4 | 5 | 6;
export type HouseLevel = 0 | 1 | 2 | 3 | 4;    // 0 tent, 1 cottage, 2 bigger main room, 3 + back room, 4 + side room
/** rev 10 (D-04, owner decision): the KayKit Medieval Hexagon cottage colours; a house roof is one of these, chosen at the cottage upgrade. */
export const ROOF_COLORS = ['red', 'blue', 'yellow', 'green'] as const;
export type RoofColor = (typeof ROOF_COLORS)[number];
export type ToolKind = 'rod' | 'shovel';
export type Footprint = readonly [w: 1 | 2 | 3, d: 1 | 2 | 3];
